import toast from "react-hot-toast";
import { getToken, getUser, refreshPage, toastStyle } from '../Utils/Common';
import { getAPICall, getWithParamsAPICall, postAPICall, postAPICall2, putAPICall } from './axiosMethodCalls';

/***************************
 * FILTER
 ***************************/

const user = getUser();
const token = getToken();

//POST
export const createUser = async (info, branches) => {
    try {
        const response = await postAPICall(process.env.REACT_APP_LINK + 'users/create', {
            requester: user,
            token: token,
            username: info.username,
            password: info.password,
            confirm_password: info.confirm_password,
            // last_name: info.last_name,
            // first_name: info.first_name,
            // middle_name: info.middle_name,
            full_name: info.full_name,
            email: info.email,
            role_id: info.role_id,
            branch_ids: branches
        });
        return ({data:response.data});
    }
    catch (error) {
        if (error.response.status === 401) {
          toast.error(
            "Unauthorized access: another device is using this account", {style: toastStyle(),}
          );
        //   removeSession();

        }
        return ({ error: error.response });
    }
}

export const updateUser = async (data) => {
    try {
        const params = new URLSearchParams()
        params.append('full_name',data.full_name)
        params.append('updated_by',getUser())
        params.append('token',getToken())
        // params.append('first_name',data.first_name)
        // params.append('last_name',data.last_name)
        // params.append('email',data.email)
        params.append('role_id',data.role_id)
        params.append('username',data.username)
        params.append('password',data.password)
        // params.append('confirm_password',data.confirm_password)

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "users/update/" + data.id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const resetPassword = async (data, userid) => {
    try {
        const params = new URLSearchParams()
        params.append('updated_by',getUser())
        params.append('token',getToken())
        params.append('password',data.password)

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "users/reset_password/" + userid.id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};
// export const editUser = async (info, branches) => {

//     // var branchesData = [];

//     // branches.map((data) => {
//     //     branchesData.push(data.value);
//     // })

//     try {
//         const response = await postAPICall(process.env.REACT_APP_LINK + 'users/update', {
//             requester: user,
//             token: token,
//             user_id: info.id,
//             username: info.username,
//             password: info.password,
//             last_name: info.last_name,
//             first_name: info.first_name,
//             middle_name: info.middle_name,
//             email: info.email,
//             type: info.type,
//             // status: info.status,
//             // branch_ids: branchesData.join(","),
//             branch_ids: branches
//         });
//         return ({ data: response });

//     } catch (error) {
//         if (error.response.status === 401) {
//           toast.error(
//             "Unauthorized access: another device is using this account", {style: toastStyle(),}
//           );
//         //   removeSession();

//         }
//         return ({ error: error.response });
//     }
// }

export const editPassword = async (id, password, token, userKey, userId) => {
    let config = {
        headers: {
            "api-key": "fJcibSRzJQv2NmJmzgnxsgMu56ucqpLBlJIA9FfaQMI9XxQ0Kxm2sEoMQfwisy0b",
            "user-key": userKey,
            "Content-Type": "application/json",
        }
    }
    try {
        const response = await postAPICall2(process.env.REACT_APP_LINK + 'users/change_password', {
            requester: id,
            user_id: userId,
            token: token,
            password: password,
        }, config);
        return ({ data: response });
    } catch (error) {
        if (error.response.status === 401) {
          toast.error(
            "Unauthorized access: another device is using this account", {style: toastStyle(),}
          );
        //   removeSession();

        }
        return ({ error: error.response });
    }
}


export const getSingleUser = async (id) => {
    try {
        const response = await getWithParamsAPICall(process.env.REACT_APP_LINK + 'users/get_user', {
            requester: user,
            token: token,
            user_id: id,
        });
        return { data: response.data.data }

    } catch (error) {
        if (error.response.status === 401) {
          toast.error(
            "Unauthorized access: another device is using this account", {style: toastStyle(),}
          );
        //   removeSession();

        }
        return ({error: error.response});

}
}
export const getQR = async (table) => {
    try {
        const response = await getAPICall(process.env.REACT_APP_LINK + 'qrcodes/show/'+table+"?table_no="+table, {
        });
        return { data: response.data.data }

    } catch (error) {
        if (error.response.status === 401) {
          toast.error(
            "Unauthorized access: another device is using this account", {style: toastStyle(),}
          );
        //   removeSession();

        }
        return ({error: error.response});

}
}

export const getAllUsers = async (id) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "users/getAll",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};


export const searchUser = async (username) => {
    try {
        const response = await getWithParamsAPICall(process.env.REACT_APP_LINK + 'users/search', {
            requester: user,
            token: token,
            term: username,
        });
        return ({ data: response });
    } catch (error) {
        if (error.response.status === 401) {
          toast.error(
            "Unauthorized access: another device is using this account", {style: toastStyle(),}
          );
        //   removeSession();

        }
        return ({ error: error.response });
    }
}

// export const searchUser = async (data) => {
//     try {
//         const response = await postAPICall(process.env.REACT_APP_LINK + 'users/search', {
//             requester: user,
//             token: token,
//             name: data,
//         });
//         return ({ data: response });
//     } catch (error) {
//         if (error.response.status === 401) {
//           toast.error(
//             "Unauthorized access: another device is using this account", {style: toastStyle(),}
//           );
//         //   removeSession();

//         }
//         return ({ error: error.response });
//     }
// }

export const deleteUser = async (id) => {
    try {
        const params = new URLSearchParams();
        params.append('updated_by',getUser())
        params.append('token',getToken())

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "users/delete/" + id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getAllRoles = async () => {
    try {
        const response = await postAPICall(process.env.REACT_APP_LINK + 'roles/filtered_get', {
            requester: user,
            token: token,
        });
        return ({ data: response.data.data });
    } catch (error) {
        if (error.response.status === 401) {
            toast.error(
                "Unauthorized access: another device is using this account"
            );
            //   removeSession();

        }
        return ({ error: error.response });
    }
}





